import { NgModule } from '@angular/core';
import { MyCurrencyPipe } from './my-currency.pipe';
import { ParseIngredientsPipe } from './parse-ingredients.pipe';

@NgModule({
  declarations: [MyCurrencyPipe, ParseIngredientsPipe],
  exports: [MyCurrencyPipe, ParseIngredientsPipe],
})
export class PipesModule {}
